// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__7Lkk5","alertIcon":"ConfirmModal_alertIcon__1slzm"};